<template>
  <CreateOrderLayout :disable-next-btn="isNextBtnDisabled" @next="next">
    <div class="kt-portlet">
      <div class="kt-portlet__head">
        <div class="kt-portlet__head-label">
          <h3 class="kt-portlet__head-title">
            How complex are your images?
            <small>
              Please select the appropriate level of image complexity. If you
              are not sure then go through request for quotation process.
            </small>
          </h3>
        </div>
      </div>
      <div class="kt-portlet__body">
        <div class="row no-gutters justify-content-md-center">
          <ImageComplexityType
            v-for="complexity in complexities"
            :key="complexity.id"
            :complexity="complexity"
            v-model.number="complexityModel"
            @change="updateBulkcomplexityId"
          />

          <ImageComplexityType
            v-if="service.allow_quotation"
            :complexity="complexityNotSure"
            v-model="complexityModel"
            :quotation-request="true"
            @change="updateBulkcomplexityId"
          />
        </div>
      </div>
      <div>
        <div class="border"></div>
        <div class="kt-portlet__head">
          <div class="kt-portlet__head-label">
            <h3 class="kt-portlet__head-title">
              All your image selected as
              <strong style="color: #5d78ff" v-if="complexityModel">
                {{ complexityName(complexityModel) }}
              </strong>
              but you can change individual image complexity from below.
            </h3>
          </div>
        </div>
        <div class="border"></div>
        <div class="kt-portlet__body">
          <div class="row">
            <div
              class="col-xl-2 col-6 col-sm-4 col-md-3 mb-2 d-flex flex-column justify-content-end "
              v-for="image in images"
              :id="`image-${image.id}`"
              :key="image.id"
            >
              <div class="upload">
                <img :src="image.url" alt class="w-100" />
              </div>
              <select
                class="form-control"
                style="color: #5d78ff;"
                :disabled="isQuotationRequest"
                @change="updateComplexityId(image.id)"
              >
                <template v-if="isQuotationRequest">
                  <option :selected="isQuotationRequest">
                    Not sure
                  </option>
                </template>
                <template v-else>
                  <option
                    v-for="complexity in complexities"
                    :key="complexity.id"
                    :value="complexity.id"
                    :selected="complexity.id === complexityModel"
                  >
                    {{ complexity.title }}
                  </option>
                </template>
              </select>
              <div
                class="upload-btn d-flex justify-content-between image-bottom"
              >
                <button
                  class="btn btn-xs"
                  @click.prevent="
                    showInstructionModal(
                      image.id,
                      image.original_name,
                      image.instruction
                    )
                  "
                >
                  <i class="flaticon-chat-2"></i>
                </button>
                <button
                  v-if="images.length > 1"
                  class="ml-1 btn btn-xs"
                  @click.prevent="confirmImageDelete(image.id)"
                >
                  <i class="flaticon-delete"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal name="image-instruction-modal" :clickToClose="false">
      <div class="kt-portlet">
        <div class="kt-portlet__head">
          <div class="kt-portlet__head-label">
            <h3 class="kt-portlet__head-title">{{ selectedImageName }}</h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <textarea
            class="form-control"
            rows="5"
            placeholder="Write here"
            v-model="selectedImageInstruction"
          ></textarea>
        </div>
        <div class="kt-portlet__foot">
          <div class="kt-form__actions kt-form__actions--right">
            <div class="row">
              <div class="col kt-align-right">
                <button
                  type="button"
                  :disabled="busy"
                  :class="{ disabled: busy }"
                  class="btn btn-secondary"
                  @click.prevent="hideInstructionModal"
                >
                  Close
                </button>
                <button
                  type="button"
                  :disabled="busy"
                  :class="{ disabled: busy }"
                  class="btn btn-brand ml-2"
                  @click.prevent="updateImageInstruction"
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </modal>
  </CreateOrderLayout>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import CreateOrderLayout from "@/layouts/CreateOrderLayout.vue";
import ImageComplexityType from "@/components/ImageComplexityType.vue";
import BeforeLeaveOrderFormMixin from "@/mixins/beforeLeaveOrderForm.js";
export default {
  name: "StepTwo",
  components: {
    CreateOrderLayout,
    ImageComplexityType,
  },
  mixins: [BeforeLeaveOrderFormMixin],
  data() {
    return {
      complexityModel: null,
      complexityNotSure: {
        id: "quotation-request",
        description: null,
        price: 0,
        sample: "",
        title: "Not Sure",
      },
      selectedImageId: null,
      selectedImageName: null,
      selectedImageInstruction: "",
      busy: false,
    };
  },
  computed: {
    ...mapGetters({
      uuid: "order/uuid",
      complexities: "service/complexities",
      service: "service/service",
      images: "order/images",
      complexityId: "order/complexityId",
      isQuotationRequest: "order/isQuotationRequest",
    }),

    isNextBtnDisabled() {
      if (this.complexityModel == null) {
        return true;
      }

      return false;
    },
  },
  watch: {
    complexityModel(newValue) {
      this.setComplexity({
        complexityId: newValue,
      });
    },
  },

  mounted() {
    this.complexityModel = this.complexityId;
  },

  methods: {
    ...mapActions({
      setComplexity: "order/setComplexity",
      updateComplexity: "order/updateComplexity",
      updateBulkComplexity: "order/updateBulkComplexity",
      setQuotationRequest: "order/setQuotationRequest",
      updateImage: "order/updateImage",
      deleteImage: "order/deleteImage",
    }),
    complexityName(id) {
      let name = "";
      this.complexities.forEach((complexity) => {
        if (id === complexity.id) {
          name = complexity.title;
        }
      });

      return name;
    },
    updateComplexityId(imageId) {
      this.updateComplexity({
        imageId: imageId,
        complexityId: event.target.value,
      }).catch(() => {
        this.$swal({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      });
    },
    updateBulkcomplexityId() {
      if (this.complexityModel === "quotation-request") {
        this.setQuotationRequest(true);
        return;
      }

      this.updateBulkComplexity({
        token: this.uuid,
        complexityId: this.complexityModel,
      })
        .then(() => {
          this.setQuotationRequest(false);
        })
        .catch(() => {
          this.$swal({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
        });
    },

    next() {
      if (this.complexityModel == null) {
        this.$swal({
          icon: "error",
          title: "Oops...",
          text: "Please select order image complexity!",
        });

        return;
      }

      this.$router.push({
        name: "step-three",
        params: { slug: this.service.slug },
        query: { ...this.$route.query },
      });
    },

    showInstructionModal(id, name, instruction) {
      this.selectedImageId = id;
      this.selectedImageName = name;
      this.selectedImageInstruction = instruction;
      this.$modal.show("image-instruction-modal");
    },
    hideInstructionModal() {
      this.$modal.hide("image-instruction-modal");
      this.resetInstructionForm();
    },
    resetInstructionForm() {
      this.selectedImageId = null;
      this.selectedImageName = null;
      this.selectedImageInstruction = "";
    },
    updateImageInstruction() {
      if (this.busy) {
        return;
      }
      this.busy = true;

      this.updateImage({
        id: this.selectedImageId,
        instruction: this.selectedImageInstruction,
      })
        .then(() => {
          this.$swal({
            icon: "success",
            title: "Image instruction updated successfully.",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        })
        .catch(() => {
          this.$swal({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
        })
        .finally(() => {
          this.busy = false;
          this.hideInstructionModal();
        });

      // document.querySelector(
      //   "#image-" + this.selectedImageId + " img"
      // ).style.borderColor = "#38a169";

      // document.querySelector(
      //   "#image-" + this.selectedImageId + " .image-bottom"
      // ).style.borderColor = "#38a169";
    },

    confirmImageDelete(imageId) {
      this.$swal({
        title: "Remove Image?",
        text: "This will remove the image from the order.",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Remove It",
        cancelButtonText: "No, Keep It",
      }).then((result) => {
        if (result.value) {
          this.onDelete(imageId);
        }
      });
    },

    onDelete(id) {
      this.deleteImage({ id: id }).catch((error) => {
        this.$swal({
          icon: "error",
          title: "Oops...",
          text: error?.response
            ? "Sorry, unable to delete the image at this moment."
            : (error?.message || "Sorry, unable to delete the image at this moment."),
        });
      });
    },
  },
};
</script>
